import axios from "axios";

const BASE_URL = `/m-1/documents`;

/**
 * Serwis do komunikacji z API - endpoint /trusted-profile
 */
export const DocumentsService = {
  getUserForm,
  downloadDeclarationById,
  getContractDataByClientId,
  getContractAccountNumberAndStatus,
  downloadContractByUuid
};

function getUserForm(client_id) {
  return axios.get(`${BASE_URL}/client-form/${client_id}`);
}

function downloadDeclarationById(statementId) {
  return axios.get(`${BASE_URL}/dowload-statment/${statementId}`, {
    responseType: "blob",
  });
}

async function getContractDataByClientId(client_id, contractNumber) {
  if (!client_id) {
    return { data: null, meta: { reason: "no-client-id" } };
  }
  try {
    const res = await axios.get(`${BASE_URL}/client-contract/${client_id}/${contractNumber}`);
    return res; 
  } catch (e) {
    const status = e?.response?.status;
    if (status === 404 || status === 500) {
      return { data: null, meta: { error: status } };
    }
    throw e;
  }
}

function getContractAccountNumberAndStatus(client_id, contract_number) {
  return axios.get(`${BASE_URL}/contract-status/${client_id}/${contract_number}`);
}

function downloadContractByUuid(uuid, fileType) {
  return axios.get(`${BASE_URL}/client-contract/download/${uuid}/${fileType}`, {
    responseType: "blob",
  });
}
